interface PremiumCheckmarkProps {
  size?: number;
  color?: string;
}

const PremiumCheckmark = ({ size = 20, color = "#1D9BF0" }: PremiumCheckmarkProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7508 10.4167C18.7508 9.1 18.0217 7.95833 16.9608 7.41667C17.0892 7.05417 17.1592 6.6625 17.1592 6.25C17.1592 4.40833 15.7342 2.91833 13.9775 2.91833C13.5858 2.91833 13.2108 2.98833 12.8642 3.12667C12.3492 2.0125 11.2592 1.25 10.0008 1.25C8.7425 1.25 7.65417 2.01417 7.13667 3.125C6.79083 2.9875 6.415 2.91667 6.02333 2.91667C4.265 2.91667 2.84167 4.40833 2.84167 6.25C2.84167 6.66167 2.91083 7.05333 3.03917 7.41667C1.97917 7.95833 1.25 9.09833 1.25 10.4167C1.25 11.6625 1.90167 12.7483 2.86833 13.3217C2.85167 13.4633 2.84167 13.605 2.84167 13.75C2.84167 15.5917 4.265 17.0833 6.02333 17.0833C6.415 17.0833 6.79 17.0117 7.13583 16.875C7.6525 17.9867 8.74083 18.75 10 18.75C11.26 18.75 12.3483 17.9867 12.8642 16.875C13.21 17.0108 13.585 17.0817 13.9775 17.0817C15.7358 17.0817 17.1592 15.59 17.1592 13.7483C17.1592 13.6033 17.1492 13.4617 17.1317 13.3208C18.0967 12.7483 18.7508 11.6625 18.7508 10.4175V10.4167ZM13.2375 7.63833L9.62583 13.055C9.505 13.2358 9.3075 13.3333 9.105 13.3333C8.98583 13.3333 8.865 13.3 8.75833 13.2283L8.6625 13.15L6.65 11.1375C6.40583 10.8933 6.40583 10.4975 6.65 10.2542C6.89417 10.0108 7.29 10.0092 7.53333 10.2542L9.00833 11.7267L12.1958 6.94333C12.3875 6.65583 12.7758 6.58 13.0625 6.77083C13.3508 6.9625 13.4292 7.35083 13.2375 7.6375V7.63833Z"
      fill={color}
    />
  </svg>
);

export default PremiumCheckmark;
